import React from 'react';
import { format, processImagePath } from '../../../../../../../util/Functions';
import './ProposalItemDetails.scss';

export default function ProposalItemDetails({ proposalItem, currency }) {
	const { common_item, quantity, price, total, item } = proposalItem;
	const { name, description, image_0, image_1, retail_price, common_sku } = common_item ?? item ?? {};
	const [imageUrl, setImageUrl] = React.useState(image_0);

	const onLoad = ({ target }) => {
		target.classList.remove("loading");
	}
	
	const onError = () => {
		if (image_1 && imageUrl !== image_1) {
			setImageUrl(image_1);
		}
	}
	
	return (
		<div data-component="ProposalItemDetailsContainer">
			<div data-component="ProposalItemDetails">
				<div className="item-image">
					<img
						src={processImagePath(imageUrl)}
						alt={name}
						loading="lazy"
						className="loading"
						onError={onError}
						onLoad={onLoad}
					/>
				</div>
				<div className="info">
					<div className="item-info">
						<h3>{name}</h3>
						<p>{description}</p>
						<div className="details">
							{retail_price != null && (
								<p className="retail-price">
									MSRP: {format(retail_price, { type: 'currency', currency })}
								</p>
							)}
							<p>SKU: {common_sku}</p>
						</div>
					</div>
					<div className="item-pricing">
						<div className="quantity">Qty: {format(quantity, { type: 'number' })}</div>
						<div className="price">
							{format(price, { type: 'currency', currency })}
							<span>ea</span>
						</div>
						<div className="total">{format(total, { type: 'currency', currency })}</div>
					</div>
				</div>
			</div>
		</div>
	);
}
